import React, { useEffect, useState } from "react";
import styles from "./Settings.module.css";

export default function Settings() {
  const [soundEnabled, setSoundEnabled] = useState(true);

  // Load saved setting from localStorage (or default true)
  useEffect(() => {
    const saved = localStorage.getItem("soundEnabled");
    if (saved !== null) setSoundEnabled(saved === "true");
  }, []);

  // Whenever sound is toggled, update app + localStorage
  useEffect(() => {
    localStorage.setItem("soundEnabled", soundEnabled);
    if (window.MyPackage?.disableSound) {
      if (soundEnabled) {
        window.MyPackage.disableSound(false);
      } else {
        window.MyPackage.disableSound(true);
      }
    }
  }, [soundEnabled]);

  const toggleSound = () => {
    setSoundEnabled((prev) => !prev);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>🔊 Sound Settings</h2>

      <div className={styles.settingRow}>
        <span>Enable Sound</span>
        <label className={styles.switch}>
          <input
            type="checkbox"
            checked={soundEnabled}
            onChange={toggleSound}
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      <p className={styles.note}>
        {soundEnabled ? "Sound is ON" : "Sound is OFF"}
      </p>
    </div>
  );
}
